import React from "react";
import SupportDesk from "../HelpDesk";
import { indiaOperations } from "../../utils/indiaOperationsSource";

/** India "Support" page: the Australian Support page on India support cases. */
const IndiaSupport = () => <SupportDesk source={indiaOperations} />;

export default IndiaSupport;
